import React from 'react';

const GenbiLandingPage = ({ canCreatePreset = null }) => {
  return (
      <div className="ev-card-4 dashboard-landing-container mt-2 d-flex align-items-center justify-content-center">
        <div style={{ maxWidth: '480px', width: '100%' }}>
          <div className="ev-card-9 p-3 text-center mb-2">
            <p className="ev-med-p-blue mb-0">Get Started</p>
          </div>
          {canCreatePreset === true && (
            <>
              <div className="ev-card-9 p-3 mb-2">
                <p className="ev-small-p-dark mb-0 ev-reg">1. Click on <span className="ev-btn-yellow-fill-round ev-bold-reg ev-btn-xsmall">Import Preset</span> to generate a dossier section.</p>
              </div>
              <div className="ev-card-9 p-3">
                <p className="ev-small-p-dark mb-0 ev-reg">2. Browse your saved Preset in the panel on the left.</p>
              </div>
            </>
          )}
          {canCreatePreset === false && (
            <>
              <div className="ev-card-9 p-3 mb-2">
                <p className="ev-small-p-dark mb-0 ev-reg">1. Open a Dossier Preset from the panel on the left to view its sections and reports.</p>
              </div>
              <div className="ev-card-9 p-3">
                <p className="ev-small-p-dark mb-0 ev-reg">2. You have view-only access. To add a preset, ask a Project Manager or Dossier Development Lead.</p>
              </div>
            </>
          )}
        </div>
      </div>
  );
};

export default GenbiLandingPage;
